import { InputDescription } from '@mantine/core';
import { defaultInputProps } from '../default-props';
export const inputDescriptionProps = InputDescription.extend({
    defaultProps: defaultInputProps,
});
